import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import classNames from 'classnames';
import he from 'he';
import isEmpty from 'lodash/isEmpty';

import Property from '../../Property';
import { IconCollapse } from '../../../components/ui/IconCollapse';
import { IconExpand } from '../../../components/ui/IconExpand';
import {
    normalizeProductValue,
    getProductsWithCategory,
    isCategoryRowHighlighted,
} from '../../../utils';

import DevCategoryPriority from '../../DevCategoryPriority';
import { ProductsParametersApi } from '@pes-ui/utils/lib/types/api/products-parameters-api';
import { MappedProduct } from '../../../utils/mappers';

import styles from '../index.module.scss';
import MobileRunTimeWidget from '../MobileRunTimeWidget';
import { ComparatorRuntimeInfo } from '@pes-ui/utils/lib/types/comparator';

type Props = {
    category: ProductsParametersApi.Section;
    currentStateKey: string; //ProductsParametersApi.Section['priority'] + '_' + ProductsParametersApi.Section['name'];
    toggleSectionHandler: (currentStateKey) => void;
    toggleState: Record<string, boolean>[string]; //ProductsParametersApi.Section['priority'] + '_' + ProductsParametersApi.Section['name'];
    showDevPrioritiesInfo: boolean;
    leftProduct: MappedProduct;
    rightProduct: MappedProduct;
    products: MappedProduct[];
    runtimeInfo: ComparatorRuntimeInfo;
    match: {
        params: {
            compareSessionId: string;
            skus: string;
            runtime: string;
        },
    };
    hideSimilarFeatures: boolean;
    highlightDifferences: boolean;
    linkClickHandlerCallback?: (link: string) => void;
}

type State = {
    calculatedRunTimeValue: string;
}

export class MobileCompareResults extends Component<Props, State> {
    constructor(props) {
        super(props);

        this.state = {
            calculatedRunTimeValue: '',
        };
    }
    static defaultProps = {
        showDevPrioritiesInfo: false,
        toggleState: false,
        leftProduct: {},
        rightProduct: {},
    };

    handleToggleClick = () => {
        const { currentStateKey, toggleSectionHandler } = this.props;
        toggleSectionHandler(currentStateKey);
    };

    getCategoryBackgroundColor = (value, isRowHighlighted) => {
        const { highlightDifferences, category } = this.props;
        const isComparable = category.parameters[value].comparable;
        return isCategoryRowHighlighted(value, isRowHighlighted) && highlightDifferences && isComparable
            ? '#ECFAEE'
            : '';
    };

    renderCategoryBody() {
        const { category, leftProduct, rightProduct, products, linkClickHandlerCallback } = this.props;
        const categoryValues = Object.keys(category.parameters);

        return categoryValues.map((value, index) => {
            const categoryValue = category.parameters[value].label;

            const productsWithCategory = getProductsWithCategory(products, value);
            const isHidableRow = category.parameters[value].hidable;

            if (this.props.hideSimilarFeatures && isHidableRow) {
                return null;
            }

            if (!productsWithCategory.length) {
                return null;
            }
            //logic from run-time-calc
            return (
                <div
                    className={styles.categoryContent}
                    key={`${value}-${index}`}
                    style={{
                        background: `${this.getCategoryBackgroundColor(value, !isHidableRow)}`,
                    }}
                >
                    <div className={styles.categoryParameter} role="rowheader">
                            <React.Fragment>
                                {`${he.decode(categoryValue)}\u00A0`}
                            </React.Fragment>
                    </div>

                    <div className={styles.categoryResults}>
                        {[leftProduct, rightProduct].map((product, i) => {
                            if (isEmpty(product)) {
                                return null;
                            }
                            const productCategories = normalizeProductValue(
                                product.productCategories,
                                value,
                            );
                            return(
                                <div
                                    key={`${value}-${i}`}
                                    className={styles.categoryValue}
                                    data-row-name={value}
                                    data-product-id={product.productId}
                                >
                                    {productCategories.map((categoryItem) => {
                                        const {
                                            productUrl,
                                            productValue,
                                            hasExternalLink,
                                            chartLabel,
                                            openPopupList
                                        } = categoryItem;

                                        return((
                                                <Property
                                                    productUrl={productUrl}
                                                    productValue={productValue}
                                                    hasExternalLink={hasExternalLink}
                                                    chartLabel={chartLabel}
                                                    openPopupList={!!openPopupList}
                                                    linkClickHandlerCallback={linkClickHandlerCallback}
                                                />
                                            )
                                        );
                                    })}
                                </div>
                            );
                        })}
                    </div>
                </div>
            );
        });
    }

    render() {
        const { category, toggleState, products, runtimeInfo, leftProduct, rightProduct } = this.props;

        const categoryHeaderClasses = classNames({
            [styles.categoryHeader]: true,
            [styles.categoryHeader_collapsed]: toggleState,
            'analytics-compare-toggle': true,
        });

        const categoryParameters = Object.keys(category.parameters);

        const isSectionHidable = categoryParameters.every(item => {
            const isAllHidableRow = category.parameters[item].hidable;

            return isAllHidableRow;
        });

        return (
            <React.Fragment>
                <div
                    className={styles.categoryContainer}
                    data-item-expanded={toggleState}
                    data-category-name={category.tag}
                >
                    {/* Category title */}
                    {this.props.hideSimilarFeatures && isSectionHidable && category.name !== runtimeInfo?.mainSectionName ? null : (
                        <div className={categoryHeaderClasses} onClick={this.handleToggleClick}>
                            <h2 className={styles.categoryTitle}>
                                {category.name.replace('amp;', '')}
                            </h2>
                            <div className={styles.compareToggleBtn}>
                                {toggleState ? <IconExpand /> : <IconCollapse />}
                            </div>
                            {this.props.showDevPrioritiesInfo ? (
                                <DevCategoryPriority priority={category.priority} />
                            ) : null}
                        </div>
                    )}

                    {/* Category body */}
                    {category.name === runtimeInfo?.mainSectionName ?
                        <MobileRunTimeWidget
                            products={products.map(product => product.productId)}
                            runtimeInfo={runtimeInfo}
                            leftProduct={leftProduct}
                            rightProduct={products.length > 1 ? rightProduct : {}}
                            toggleState={toggleState}
                        />
                        :
                        null
                    }
                    {toggleState ? null : this.renderCategoryBody()}
                </div>
            </React.Fragment>
        );
    }
}


export default withRouter(MobileCompareResults);
